import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { EducatorGetEducatorQuery, EducatorGetEducatorQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';

export const EDUCATOR_GET_EDUCATOR = graphql(`
  query EducatorGetEducator($where: ProfessionalWhereInput!) {
    searchProfessionals(take: 1, where: $where) {
      professionals {
        id
        educatorType
        email
        spokenLanguages
        namePro
        mainProFirstName
        mainProLastName
        phone
        mobilePhone
        hasShop
        website
        isTipawPartner
        practicePlaces
        acceptsNewClients
        acceptedAnimals
        paymentMethods
        profileVideo
        profileVideoPos
        proSchedule {
          dayOfWeek
          avails {
            start
            end
          }
        }
        degrees {
          degree
          school
          dateEnd
        }
        imgs {
          id
          large
        }
        address {
          id
          formatted
          street
          streetNumber
          city
          zip
          lat
          lng
          country
        }
        translations {
          id
          language
          url
          title
          description
          extraDescription
          subtitle
          wellnessEngagement
          preBookingWarning
          seoTitle
          seoDescription
          seoKeywords
        }
      }
    }
  }
`);

export const useGetEducator = (url: string) => {
  const { language } = useRouter();

  const variables = useMemo((): EducatorGetEducatorQueryVariables => {
    return {
      where: {
        published: { equals: true },
        OR: [
          {
            translations: {
              some: {
                AND: [{ url: { equals: url } }, { language: { equals: language } }],
              },
            },
          },
          { proMongoId: { equals: url } },
        ],
      },
    };
  }, [url, language]);

  const { data, error, loading } = useQuery<
    EducatorGetEducatorQuery,
    EducatorGetEducatorQueryVariables
  >(EDUCATOR_GET_EDUCATOR, {
    variables,
  });

  return {
    educator: data?.searchProfessionals.professionals?.[0],
    educatorError: error,
    educatorLoading: loading,
  };
};
